import { render, staticRenderFns } from "./ImportPatients.vue?vue&type=template&id=6e21a35a&"
import script from "./ImportPatients.vue?vue&type=script&lang=js&"
export * from "./ImportPatients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports